
import useArticlesState from './useArticlesState';
import { getIsArticlesLoaded } from '../reducers/common/articles';

export default function useIsArticlesLoaded() {
    return getIsArticlesLoaded(useArticlesState());
}
